// extracted by mini-css-extract-plugin
export default {"admin":"admin_admin__CqO+5","admin__inner":"admin_admin__inner__Fj3dV"};